<form role="form" [formGroup]="levelForm">
<h1 mat-dialog-title>LEVEL</h1>
<div mat-dialog-content>
  <p>{{data.title}}</p>
  
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Name of Level</mat-label>
      <input matInput formControlName="description">
    </mat-form-field>
  </p>
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Hierachy</mat-label>
      <input matInput type="number" formControlName="heirarchy">
    </mat-form-field>
  </p>
  
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Close</button>
  <button mat-button [mat-dialog-close]="" cdkFocusInitial (click)="addLevel()">Save</button>
</div>
</form>
